const fr = {
  questionPaperLibrary: "Bibliotheque de sujets",
  questionPaperLibraryDescription:
    "Votre espace de travail dynamique pour creer des questions individuelles et concevoir des questionnaires complets.",
  assessmentLibrary: "Bibliotheque d'evaluations",
  assessmentLibraryDescription:
    "Gerez les planifications, invitez les participants et suivez les rapports de performance depuis un hub centralise.",
  myAssessmentWidgetTitle: "Mon evaluation",
  myPreferences: "Mes préférences",
  assessmentsForYou: "Evaluations pour vous",
  exploreAssessmentsAssignedToYou:
    "Explorez les evaluations qui vous sont attribuees",
  hitachiAcademy: "Academie Hitachi",
  essentialBusinessKnowledgeTestForYou:
    "Test essentiel de connaissances metier pour vous",
  continuousLearningJourneyDescription:
    "Concu pour vous aider a comprendre et a renforcer vos competences metier tout au long de votre parcours d'apprentissage continu",
  noActiveAssessmentsScheduledForYou:
    "Aucune evaluation active programmee pour vous",
  upcoming: "A venir",
  notAttempted: "Non tente",
  myAssessmentCardDescription:
    "Cette evaluation mesure vos competences techniques, analytiques et de resolution de problemes dans le cadre du processus de recrutement campus de GlobalLogic.",
  totalDuration: "Duree totale",
  startTime: "Heure de debut",
  questionAuthoring: "Creation de questions",
  reviewQuestions: "Revoir les questions",
  bulkUploadHistory: "Historique des televersements en lot",
  bulkActionHistory: "Historique des actions en lot",
  editQuestion: "Modifier la question",
  inviteParticipants: "Inviter des participants",
  externalUserBulkUploadHistory:
    "Historique des televersements en lot des utilisateurs externes",
  assessmentSchedule: "Calendrier des evaluations",
  assessmentReport: "Rapport d'evaluation",
  bulkHistory: "Historique en lot",
  myUpload: "Mon televersement",
  bulkUpload: "Televersement en lot",
  createQuestion: "Creer une question",
  bulkUploadQuestions: "Televersement en lot de questions",
  filters: "Filtres",
  clear: "Effacer",
  searchByTitle: "Rechercher par titre",
  refresh: "Actualiser",
  refreshing: "Actualisation",
  reviewQuestionPapers: "Examiner les questionnaires",
  myQuestionPapers: "Mes questionnaires",
  viewQuestionBank: "Voir la banque de questions",
  createNew: "Creer",
  sortBy: "Trier par",
  state: "Etat",
  reviewed: "Revu",
  reviewedTooltip:
    "Afficher les questionnaires qui ont ete revus puis publies.",
  all: "Tous",
  draft: "Brouillon",
  published: "Publie",
  inReview: "En revue",
  sentBack: "Renvoye",
  readyToPublish: "Pret a publier",
  draftDescription:
    "La creation du questionnaire est toujours en cours et pas encore disponible pour les apprenants",
  publishedDescription:
    "Le questionnaire est en ligne et accessible aux apprenants",
  inReviewDescription:
    "Le questionnaire est en cours de revue et pas encore approuve",
  sentBackDescription: "Le questionnaire a ete renvoye pour revisions",
  readyToPublishDescription: "Le questionnaire est pret a etre publie",
  createdAt: "Cree le",
  updatedAt: "Mis a jour le",
  publishedAt: "Publie le",
  descending: "Decroissant",
  ascending: "Croissant",
  yes: "Oui",
  no: "Non",
  success: "Succès",
  error: "Erreur",
  warning: "Avertissement",
  info: "Info",
  noMatchingContentFound: "Aucun contenu correspondant trouve",
  noQuestionPapersAvailableForReview:
    "Aucun questionnaire disponible pour revision",
  questionPaperNotYetCreated: "Questionnaire non encore cree",
  createQuestionPaperDescription:
    "Creez un questionnaire pour evaluer les competences et connaissances des apprenants",
  createYourFirstQuestionPaper: "Creez votre premier questionnaire",
  createQuestionPaperModalTitle: "Creer un questionnaire",
  questionsTab: "Questions",
  questionPaperSettingsTab: "Paramètres du papier à questions",
  editQuestionPaper: "Modifier le questionnaire",
  save: "Sauvegarder",
  publish: "Publier",
  sendForReview: "Envoyer pour révision",
  sendingForReview: "Envoi pour révision",
  publishing: "Publication",
  clone: "Cloner",
  delete: "Supprimer",
  view: "Voir",
  edit: "Modifier",
  close: "Fermer",
  create: "Créer",
  creating: "Création",
  confirm: "Confirmer",
  cancel: "Annuler",
  version: "Version",
  untitled: "Sans titre",
  noVersion: "Aucune version",
  title: "Titre",
  status: "Statut",
  action: "Action",
  createdBy: "Créé par",
  createNewVersion: "+ Nouvelle version",
  createNewVersionTitle: "Créer une nouvelle version",
  deleteQuestionPaperPrompt:
    "Êtes-vous sûr de vouloir supprimer ce questionnaire ?",
  deleteQuestionPaperWithTitlePrompt:
    "Voulez-vous supprimer ce questionnaire intitulé « {{title}} » ?",
  cloneQuestionPaperPrompt: "Voulez-vous cloner ce questionnaire ?",
  publishQuestionPaperPrompt:
    "Êtes-vous sûr de vouloir publier ce document de questions ?",
  sendForReviewQuestionPaperPrompt:
    "Êtes-vous sûr de vouloir envoyer ce questionnaire pour examen ?",
  successfullyDeletedQuestionPaper:
    "Le questionnaire a été supprimé avec succès",
  successfullyMovedQuestionPaperToDraft:
    "Déplacement réussi du questionnaire vers la version brouillon",
  successfullySavedQuestionPaperData:
    "Les données du questionnaire ont été enregistrées avec succès",
  successfullyClonedQuestionPaper: "Clonage réussi du questionnaire",
  successfullyCreatedQuestionPaper: "Création réussie du questionnaire",
  validationFailedWithFollowingErrors:
    "La validation a échoué avec les erreurs suivantes :",
  failedStatusUpdateOf: "Échec de la mise à jour du statut de :",
  savedWithFollowingWarnings: "Enregistré avec les avertissements suivants :",
  reviewedAndPublished: "Révisé et publié",
  deleting: "Suppression...",
  cloning: "Clonage...",
  assessment: "Évaluation",
  public: "Publique",
  private: "Privé",
  visibility: "Visibilité",
  questionType: "Type de question",
  selectQuestionTypeAndVisibility:
    "Sélectionnez le type de question et la visibilité",
  singleChoice: "Choix unique",
  multipleChoice: "Choix multiples",
  trueOrFalse: "Vrai ou faux",
  fillInTheBlanks: "Remplissez les blancs",
  codingQuestion: "Question de codage",
  subjectiveQuestion: "Question subjective",
  speakingQuestion: "Question orale",
  downloadTemplateEditAndReuploadQuestions:
    "Téléchargez le modèle, modifiez et rechargez la liste de questions",
  downloadExcelTemplateInstruction:
    "Téléchargez le modèle Excel en utilisant le bouton ci-dessous.",
  addQuestionsToSheetInstruction:
    "Ajoutez vos questions à la feuille (les instructions sont incluses à l'intérieur).",
  uploadCompletedExcelInstruction:
    "Téléchargez le fichier Excel complété pour importer des questions en masse.",
  uploading: "Téléchargement...",
  uploadQuestions: "Télécharger des questions",
  completed: "Complété",
  invalid: "Invalide",
  initiated: "Initié",
  failed: "Échoué",
  fileName: "Nom de fichier",
  templateType: "Type de modèle",
  uploadedAt: "Téléchargé à",
  actions: "Actes",
  mcqTemplate: "Modèle QCM",
  fibTemplate: "Modèle FIB",
  monitorUploadExcelDescription:
    "Surveillez chaque fichier Excel téléchargé, vérifiez combien de questions ont été ajoutées ou ont échoué et affichez les détails de l'erreur si nécessaire.",
  reset: "Réinitialiser",
  showing: "Affichage",
  to: "à",
  of: "de",
  results: "résultats",
  noExcelFound: "Aucun Excel trouvé",
  cloneAssessmentConfirmation: "Confirmation de l'évaluation du clone",
  cloneAssessmentWithTitlePrompt:
    "Êtes-vous sûr de vouloir cloner cette évaluation intitulée « {{title}} » ?",
  successfullyClonedAssessment: "Évaluation clonée avec succès",
  newVersionContentPrompt:
    "Vous êtes sur le point de créer une nouvelle version de ce contenu. Toute modification ultérieure sera enregistrée dans cette version. Souhaitez-vous continuer ?",
  createVersionWithNumber: "Créer (V{{version}})",
  addYourComment: "Ajoutez votre commentaire",
  maxLimitReached: "limite maximale atteinte",
  deleteContentPrompt:
    "Êtes-vous sûr de vouloir supprimer ce {{contentType}} ?",
  deleteContentWithTitlePrompt:
    "Êtes-vous sûr de vouloir supprimer ce {{contentType}} intitulé « {{title}} » ?",
  schedulePreview: "Aperçu du calendrier",
  reschedule: "Reprogrammer",
  cancelled: "Annulé",
  copyLink: "Copier le lien",
  assessmentIsCancelled: "L'évaluation est annulée",
  deleteConfirmation: "Confirmation de suppression",
  cancelConfirmation: "Annuler la confirmation",
  deleteAssessmentPrompt:
    "Êtes-vous sûr de vouloir supprimer cette évaluation ?",
  cancelAssessmentPrompt: "Êtes-vous sûr de vouloir annuler cette évaluation ?",
  rescheduleAssessment: "Reprogrammer l'évaluation",
  customTermsAndConditions: "Conditions générales personnalisées",
  viewTermsAndConditions: "Voir les conditions générales",
  scheduleNewAssessment: "Planifier une nouvelle évaluation",
  selectQuestionPaper: "Sélectionnez le papier de questions",
  createAssessment: "Créer une évaluation",
  failedToLoadData: "Échec du chargement des données !",
  assessmentNotYetCreated: "Évaluation pas encore créée",
  createAssessmentDescription:
    "Créer un bilan pour évaluer les compétences et les connaissances des apprenants",
  createYourFirstAssessment: "Créez votre première évaluation",
  failedToLoadSchedules: "Échec du chargement des plannings",
  errors: "Erreurs :",
  basicInformation: "Informations de base",
  assessmentName: "Nom de l'évaluation",
  na: "N / A",
  scheduleInstructions: "Instructions pour le calendrier",
  noInstructionsProvided: "Aucune instruction fournie",
  accessCriteria: "Critères d'accès",
  searchTags: "Rechercher des balises",
  viewAttributes: "Afficher les attributs",
  termsAndConditions: "Conditions générales",
  enabled: "Activé",
  disabled: "Désactivé",
  requireCandidatesToAcceptTerms:
    "Exiger des candidats qu'ils acceptent les conditions générales avant de commencer l'évaluation",
  proctoringSettings: "Paramètres de surveillance",
  enableVideoProctoring: "Activer la surveillance vidéo",
  maximumVideoViolationsAllowed:
    "Nombre maximal de violations vidéo autorisées",
  enableBrowserProctoring: "Activer la surveillance du navigateur",
  maximumBrowserViolationsAllowed:
    "Violations maximales du navigateur autorisées",
  displayViolationsToCandidates: "Afficher les violations aux candidats",
  actionWhenViolationLimitReached:
    "Action lorsque la limite de violation est atteinte",
  flagged: "Signalé",
  terminate: "Terminer",
  stakeholdersAndFeedback: "Parties prenantes et commentaires",
  owner: "Propriétaire",
  recruiter: "Recruteur",
  allowCandidateFeedback: "Autoriser les commentaires des candidats",
  enableCandidateFeedbackDescription:
    "Permettre aux candidats de soumettre des commentaires après avoir terminé l'évaluation",
  schedulingAndTimerSettings: "Paramètres de planification et de minuterie",
  scheduleType: "Type d'horaire",
  loginWindow: "Fenêtre de connexion",
  durationBased: "Basé sur la durée",
  deadline: "Date limite",
  autoCompleteMode: "Mode de saisie semi-automatique",
  startDateAndTime: "Date et heure de début",
  loginWindowInMinutes: "Fenêtre de connexion (en minutes)",
  endDateAndTime: "Date et heure de fin",
  timerEnabled: "Minuterie activée",
  assessmentRules: "Règles d'évaluation",
  assessmentPattern: "Modèle d'évaluation",
  resultVisibility: "Visibilité des résultats",
  passPercentage: "Pourcentage de réussite",
  maximumAttemptsAllowed: "Nombre maximal de tentatives autorisées",
  unlimitedAttempts: "Tentatives illimitées",
  attempt: "tentative",
  attempts: "tentatives",
  coolOffPeriodBetweenAttempts: "Période de réflexion entre les tentatives",
  questionDisplaySettings: "Paramètres d'affichage des questions",
  showQuestionTitle: "Afficher le titre de la question",
  showQuestionTitleDescription:
    "Afficher le titre de la question au-dessus de chaque question",
  showHint: "Afficher l'indice",
  hintLoading: "Vous devez attendre avant de voir un autre indice",
  allHintsShown: "Aucun indice en attente",
  showHintDescription:
    "Activer les astuces pour aider le candidat pendant l'évaluation",
  showExplanation: "Afficher l'explication",
  hideExplanation: "Masquer l'explication",
  showExplanationDescription:
    "Afficher des explications après chaque soumission de question",
  showQuestionMarks: "Afficher les points d'interrogation",
  showQuestionMarksDescription:
    "Afficher la valeur de note/score pour chaque question",
  showWatermark: "Afficher le filigrane",
  showWatermarkDescription:
    "Afficher l'email du candidat pour chaque question en filigrane",
  questionPaperPreview: "Aperçu du papier de questions",
  questionPaperReview: "Examen des documents de questions",
  createSchedule: "Créer un calendrier",
  reviewerComments: "Commentaires des évaluateurs",
  reviewComments: "Commentaires de révision",
  sendBackQuestionPaperPrompt:
    "Êtes-vous sûr de vouloir renvoyer ce questionnaire ?",
  moveQuestionPaperToDraftPrompt:
    "Êtes-vous sûr de vouloir déplacer ce questionnaire vers l'état de brouillon ?",
  markQuestionPaperReadyToPublishPrompt:
    "Êtes-vous sûr de vouloir marquer ce questionnaire comme prêt à être publié ?",
  questionPaperStatusUpdatedSuccessfully:
    "Le statut du questionnaire a été mis à jour avec succès !",
  newVersionQuestionPaperCreatedSuccessfully:
    "Nouvelle version du papier à questions créée avec succès !",
  questionPaperClonedSuccessfully: "Questionnaire cloné avec succès !",
  startAddingQuestionsPreview:
    "Commencez à ajouter des questions pour en avoir un aperçu ici",
  bulkInviteParticipants: "Inviter des participants en masse",
  bulkInviteParticipantsDescription:
    "Invitez plusieurs participants à la fois en téléchargeant un fichier Excel pré-rempli. Veuillez utiliser le modèle fourni pour garantir le format correct.",
  maxParticipantsPerFileNote:
    "Max 200 participants par fichier. Les entrées en double ou invalides seront ignorées avec une erreur.",
  downloadTemplate: "Télécharger le modèle",
  creatingUser: "Création d'un utilisateur...",
  bulkInviteLabel: "Invitation groupée",
  createAndInvite: "Créer et inviter",
  myUploads: "Mes téléchargements",
  enterIndividualsForInvite:
    "Entrez les noms d'une ou plusieurs personnes que vous souhaitez inviter à l'évaluation",
  searchPeopleByEmailOrName: "Rechercher des personnes par e-mail ou par nom",
  noResultsFound: "Aucun résultat trouvé",
  loading: "Chargement..",
  or: "Ou",
  multipleEmailsInviteDescription:
    "Ajoutez plusieurs e-mails d'utilisateurs, séparés par des virgules, pour inviter plusieurs utilisateurs à l'évaluation",
  addCandidates: "Ajouter des candidats",
  pleaseEnterValidNameOrEmail:
    "Veuillez saisir un nom ou une adresse e-mail valide",
  pleaseEnterValidEmailAddress:
    "S'il vous plaît, mettez une adresse email valide",
  someEmailsCouldNotBeAdded:
    "Certaines adresses e-mail n'ont pas pu être ajoutées",
  checkInvalidEmailIds:
    "Veuillez vérifier les identifiants de messagerie suivants : ils semblent être invalides :",
  failedToSendInvitesFollowingEmails:
    "Échec de l'envoi des invitations aux e-mails suivants :",
  successfullyInvitedMembers: "Membre {{count}} invité avec succès",
  validationFailed: "Échec de la validation",
  excelUploadedSuccessfully: "Excel téléchargé avec succès",
  invalidBulkNominationTemplate: "Modèle de nomination groupée non valide",
  actionCompletedWithWarnings:
    "Action terminée avec les avertissements suivants :",
  actionFailedWithErrors:
    "L'action n'a pas pu être terminée et quittée avec les erreurs suivantes :",
  trackBulkOperationsAndResults:
    "Suivez toutes vos opérations groupées et leurs résultats",
  partiallySaved: "Partiellement enregistré",
  statusInitiatedDescription:
    "La demande de mise à jour des questions a été soumise et est en cours de traitement.",
  statusCompletedDescription:
    "Toutes les questions sélectionnées ont été mises à jour avec succès.",
  statusFailedDescription:
    "Aucune des questions sélectionnées n'a pu être traitée avec succès.",
  statusPartiallySavedDescription:
    "Certaines questions ont été enregistrées avec succès, tandis que d'autres ont rencontré des problèmes.",
  draftReadyToPublishToPublish: "Brouillon/Prêt à publier -> Publier",
  actionType: "Type d'action",
  uploadedOn: "Téléchargé le",
  viewDetails: "Afficher les détails",
  loadingRecords: "Chargement des enregistrements...",
  noRecordsFound: "Aucun enregistrement trouvé",
  recordsPerPage: "Enregistrements par page :",
  page: "Page",
  untitledQuestion: "Question sans titre",
  globalLogic: "GlobalLogique",
  aiGenerated: "Généré par l'IA",
  fullScreen: "Plein écran",
  exitFullScreen: "Quitter le plein écran",
  skills: "Compétences",
  tags: "Balises",
  allowedCodingLanguages: "Langages de codage autorisés",
  marks: "Marques",
  lastUpdatedAt: "Dernière mise à jour à",
  solutionCode: "Code de solution",
  solution: "Solution",
  starterCode: "Code de démarrage",
  options: "Possibilités",
  explanation: "Explication",
  hint: "Indice",
  deleteQuestion: "Supprimer la question",
  noSections: "Aucune section ajoutée",
  editAndPublish: "Modifier et publier",
  sendBackToDraftInstruction:
    "Cliquez sur le bouton de renvoi pour renvoyer la question au brouillon.",
  updateStatusReadyToPublishInstruction:
    "Cliquez sur le bouton Prêt à publier pour mettre à jour le statut.",
  successfullyUpdatedStatus: "Le statut a été mis à jour avec succès",
  dismiss: "Rejeter",
  ongoing: "En cours",
  toBeLaunched: "À lancer",
  contentExpired: "Contenu expiré",
  notApplicable: "Non applicable",
  expiresSoon: "Expire bientôt",
  contentCreationInProgressTooltip:
    "La création du contenu est toujours en cours et n'est pas encore disponible pour les apprenants",
  contentLiveAccessibleTooltip:
    "Le contenu est en ligne et accessible aux apprenants",
  contentAvailableWithinDatesTooltip:
    "Le contenu est actuellement disponible car il est dans la période de lancement et d'expiration",
  contentNotLaunchedAvailableOnTooltip:
    "Le contenu n'a pas encore été lancé et sera disponible le",
  contentExpiredOnTooltip: "Ce contenu a expiré le",
  statusAvailableAfterPublishTooltip:
    "Le statut sera disponible une fois le contenu publié",
  contentExpiresWithin48HoursTooltip: "Le contenu expirera dans les 48 heures.",
  moveToDraftOrCloneToEdit:
    "Déplacez-le en brouillon ou clonez-le pour effectuer des modifications",
  webContent: "Contenu Web",
  eLearning: "E-learning",
  untitledContent: "Contenu sans titre",
  sendToDraft: "Envoyer en brouillon",
  sendToDraftPublishedInstruction:
    "Ce contenu est déjà publié. Pour effectuer des modifications, cliquez sur le bouton Envoyer en brouillon.",
  copyLinkForLearner: "Copier le lien pour l'apprenant",
  questionPaperName: "Nom du questionnaire",
  type: "Taper",
  duration: "Durée",
  minutes: "Minutes",
  difficultyLevel: "Niveau de difficulté",
  language: "Langue",
  timezone: "Fuseau horaire",
  preferredLocation: "Emplacement préféré",
  notSelected: "Non sélectionné",
  selectedPreferencesHeading: "Préférences sélectionnées",
  selectedPreferencesInfo:
    "Préférences sélectionnées pour une expérience fluide",
  shortDescription: "Description courte",
  totalMarks: "Score total",
  questionPaperInstructions: "Instructions du questionnaire",
  expiryDate: "Date d'expiration",
  knowledgeCategory: "Catégorie de connaissance",
  category: "Catégorie",
  subCategory: "Sous-catégorie",
  region: "Région",
  usage: "Utilisation",
  internalUseOnly: "Usage interne uniquement",
  externalUseOnly: "Usage externe uniquement",
  availableForAll: "Disponible pour tous",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Amérique latine",
  northAmerica: "Amérique du Nord",
  globalRegion: "Mondial",
  automotive: "Automobile",
  bankingFinancialServicesInsurance:
    "Services bancaires, financiers et assurance",
  connectivitySolutionsCommunication: "Solutions de connectivité/communication",
  consumerRetail: "Consommation et commerce de détail",
  healthcareLifeSciences: "Santé et sciences de la vie",
  manufacturingAndIndustrial: "Industrie manufacturière et industrielle",
  mediaEntertainment: "Médias et divertissement",
  technology: "Technologie",
  other: "Autre",
  behavioralInterpersonal: "Comportemental/Interpersonnel",
  technical: "Technique",
  processAndTools: "Processus et outils",
  polishLanguage: "Polonais",
  spanishLanguage: "Espagnol",
  japaneseLanguage: "Japonais",
  germanLanguage: "Allemand",
  ukrainianLanguage: "Ukrainien",
  swedishLanguage: "Suédois",
  romanianLanguage: "Roumain",
  slovakLanguage: "Slovaque",
  croatianLanguage: "Croate",
  englishUsLanguage: "Anglais (US)",
  englishUkLanguage: "Anglais (UK)",
  englishInLanguage: "Anglais (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Normes et protocoles automobiles",
  businessAnalysis: "Analyse métier",
  cCpp: "C/C++",
  cloudDataScience: "Science des données cloud",
  bigData: "Big Data",
  dataAnalytics: "Analyse de données",
  databaseTech: "Base de données",
  developmentTools: "Outils de développement",
  devops: "DevOps",
  embedded: "Systèmes embarqués",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Noyau Linux",
  mobileDev: "Développement mobile",
  networking: "Réseaux",
  operatingSystemsServers: "Systèmes d'exploitation et serveurs",
  otherTech: "Autre - Tech",
  productivityTools: "Outils de productivité",
  programmingLangOther: "Langage de programmation - Autre",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Ingénierie logicielle",
  uxUi: "UX/UI",
  architectureTech: "Architecture",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Ingénierie des exigences/Rédaction technique",
  onboarding: "Intégration",
  glTools: "Outils GL",
  processAndPolicies: "Processus et politiques",
  communicationSubCategory: "Communication",
  personalEffectiveness: "Efficacité personnelle",
  methodologies: "Méthodologies",
  projectManagement: "Gestion de projet",
  peopleManagement: "Gestion des personnes",
  leadershipPrograms: "Programmes de leadership",
  domain: "Domaine",
  reviewer: "Réviseur",
  none: "Aucun",
  questionPaperPreviewBreadcrumb: "Aperçu du questionnaire : {{title}}",
  questionPaperInReviewContactReviewer:
    "Ce questionnaire est actuellement en cours de révision. Veuillez contacter le réviseur.",
  randomization: "Randomisation",
  randomizationInSectionDescription:
    "Les questions de cette section seront affichees aux candidats dans un ordre aleatoire",
  questionPreviewPlaceholderImage:
    "Espace réservé pour l'aperçu de la question",
  createNewVersionPromptWithNumber:
    "Créer une nouvelle version (V{{version}}) ?",
  questionPreviewBreadcrumb: "Apercu de la question : {{title}}",
  questionPreviewTitle: "Apercu de la question",
  adminView: "Vue administrateur",
  candidateView: "Vue candidat",
  viewAsCandidate: "Voir en tant que candidat",
  closePanel: "Fermer le panneau",
  internalQuestion: "Question interne",
  expiresOn: "Expire le",
  expiredLabel: "Expire",
  solutionNotAdded: "Solution non ajoutee",
  testCases: "Cas de test",
  testCasesNotAdded: "Cas de test non ajoutes",
  starterCodeNotAdded: "Code de demarrage non ajoute",
  groupTitleLengthValidation:
    "Le titre du groupe doit contenir plus de 5 et moins de 120 caracteres",
  addTitleHere: "Ajoutez le titre ici...",
  groupUpdatedSuccessfully: "Groupe mis a jour avec succes",
  groupDeletedSuccessfully: "Groupe supprime avec succes",
  group: "Groupe",
  numberOfQuestionsToBeShown: "Nombre de questions a afficher",
  questionLimitPerSectionDescription:
    "Afficher uniquement un certain nombre de questions aux candidats dans les sections",
  numberOfQuestionsToShow:
    "Nombre de questions a afficher {{picked}}/{{total}}",
  collapseGroup: "Reduire le groupe",
  expandGroup: "Developper le groupe",
  groupSetupStartAddingQuestions:
    "Un groupe est configure pour cette section. Commencez a y ajouter des questions.",
  addMoreQuestions: "Ajouter plus de questions",
  addQuestionFromLibrary: "Ajouter une question depuis la bibliotheque",
  questionDeletedSuccessfully: "Question supprimee avec succes",
  questionsShownCountUpdated:
    "Le nombre de questions affichees a ete mis a jour",
  failedToDeleteQuestion: "Echec de la suppression de la question",
  caseSensitive: "Sensible a la casse",
  caseSensitiveDescription:
    "Si active, les apprenants doivent saisir la reponse avec exactement les memes majuscules et minuscules.",
  enterYourAnswerBelow: "Saisissez votre reponse ci-dessous",
  caseSensitiveAnswerInfo:
    "Cette question est sensible a la casse, veuillez saisir vos reponses avec les majuscules et minuscules exactes.",
  answerWithNumber: "Reponse {{number}}",
  inviteEmailsPlaceholder:
    "utilisateur1@globallogic.com,utilisateur2@globallogic.com",
  visibleTestCases: "Cas de test visibles",
  hiddenTestCases: "Cas de test caches",
  visibleLabel: "Visible",
  hiddenLabel: "Cache",
  responseSetting: "Parametres de reponse",
  recordingLimit: "Limite d'enregistrement",
  minimumResponseDuration: "Duree minimale de reponse",
  uploadLimit: "Limite de televersement",
  practiceAllowed: "Pratique autorisee",
  standardEvaluationRubricInfo:
    "Il s'agit de la grille d'evaluation standard qui sera utilisee pour evaluer la reponse du candidat a cette question.",
  criteria: "Criteres",
  weightPercentage: "Ponderation(%)",
  viewRemarks: "Voir les remarques",
  input: "Entree",
  expectedOutput: "Sortie attendue",
  actualOutput: "Sortie réelle",
  untitledSection: "Section sans titre",
  testSectionDescription: "Description de la section test",
  groupAddedSuccessfully: "Groupe ajoute avec succes",
  addGroupToSection: "Ajouter un groupe a la section",
  deleteSection: "Supprimer la section",
  questionPaperDetails: "Details du document de questions",
  skillsInfoMessage:
    "Enumerez les competences cles que ce document de questions vise a evaluer.",
  contentSettings: "Parametres de contenu",
  stakeholderAndReview: "Parties prenantes et examen",
  statusType: "Type de statut",
  notReviewed: "Non révisé",
  sourceType: "Type de source",
  proficiency: "Compétence",
  beginner: "Débutant",
  intermediate: "Intermédiaire",
  advanced: "Avancé",
  wecp: "WECP",
  enterMarks: "Saisir les notes",
  removeSkill: "Supprimer la compétence",
  searchSkills: "Compétences de recherche",
  noSkillsFound: "Aucune compétence trouvée.",
  enterTag: "Entrez une balise",
  enterOwner: "Entrez le proprietaire",
  enterReviewer: "Entrez l'examinateur",
  noUserWithRole: "Aucun utilisateur avec ce role n'a ete trouve",
  createSection: "Créer une section",
  untitledGroup: "Groupe sans titre",
  createGroup: "Créer un groupe",
  collapseSections: "Réduire les sections",
  expandSections: "Développer les sections",
  assessmentNamePlaceholder: "Veuillez saisir le nom de l'évaluation",
  questionPaperTitleInfo:
    "Entrez un titre clair et descriptif pour le questionnaire.",
  shortDescriptionPlaceholder: "Fournir une brève description",
  shortDescriptionInfo:
    "Un bref résumé expliquant ce que couvre le document de questions.",
  questionPaperInstructionsInfo:
    "Rédigez les instructions que les candidats verront avant de commencer le questionnaire. Incluez des détails importants tels que les règles de section, les formats de questions, les conseils de navigation et les directives de soumission.",
  questionPaperInstructionsPlaceholder:
    "Ajoutez toutes les instructions importantes pour les apprenants avant qu'ils ne commencent l'évaluation : durée, critères de réussite, outils autorisés ou lignes directrices.",
  totalMarksAutoCalculatedInfo:
    "Le total des notes sera automatiquement calculé en fonction du nombre de questions sélectionnées pour chaque groupe. Si le nombre de questions à afficher est fixé à 0, ce groupe sera exclu du total des notes.",
  questionPaperType: "Type de papier de questions",
  questionPaperTypeInfo: "Sélectionnez le format du papier à questions.",
  durationInfo:
    "Fixez le temps limite total pour remplir le questionnaire (en minutes).",
  difficultyLevelInfo:
    "Sélectionnez le niveau de difficulté attendu en fonction de l'expérience du candidat.",
  languageInfo:
    "Choisissez la langue dans laquelle le questionnaire sera présenté.",
  tagsInfo:
    "Ajoutez des mots-clés pour aider les autres à trouver ce questionnaire grâce à une recherche.",
  selectCategory: "Sélectionnez une catégorie",
  createLevel: "Créer",
  evaluate: "Évaluer",
  analyze: "Analyser",
  apply: "Appliquer",
  understand: "Comprendre",
  remember: "Souviens-toi",
  allowedCodingLanguagesRequiredInfo:
    "Ce champ n'est requis que lorsque vous ajoutez des questions de codage au questionnaire.",
  knowledgeCategoryInfo:
    "Sélectionnez le niveau de compétence cognitive ciblé par ce questionnaire, par exemple, Se souvenir, Comprendre, Appliquer.",
  allowedCodingLanguagesInfo:
    "Sélectionnez les langages de programmation autorisés pour coder les questions dans ce questionnaire.",
  expiryDateInfo:
    "Fixez une date facultative après laquelle ce questionnaire ne doit plus être utilisé.",
  visibilityInfo: "Sélectionnez la visibilité du papier à questions",
  visibilityLockedInfo:
    "Une fois qu'un questionnaire est publié avec une visibilité publique, toutes ses autres versions auront également une visibilité publique. De même, si elle est publiée en tant que Privée, toutes les versions resteront Privées.",
  reviewRequired: "Examen requis",
  reviewRequiredLockedInfo:
    "Le paramètre « Révision requise » est synchronisé dans toutes les versions d'un questionnaire. Si une version est publiée avec la révision activée ou désactivée, le même paramètre s'appliquera à toutes les versions et ne pourra pas être modifié individuellement.",
  reviewRequiredInfo:
    "Activez cette option si ce document de questions doit passer par un processus de révision formel avant sa publication.",
  savingData: "Sauvegarde des données...",
  questionDataSavedSuccessfully: "Données de question enregistrées avec succès",
  sendQuestionForReviewInstruction:
    "Cliquez sur le bouton Envoyer pour révision pour l'envoyer au réviseur afin qu'il soit révisé !",
  publishQuestionInstruction:
    "Cliquez sur le bouton de publication pour publier la question.",
  noLearningContentAddedAfterSelectingYes:
    "Aucun contenu d'apprentissage ajouté après avoir sélectionné Oui",
  expectedTimeInMinutes: "Temps prévu (en minutes)",
  codingMarksAutoCalculatedInfo:
    "Cette note est calculée automatiquement en fonction des cas de test cachés ajoutés à cette question",
  skillsInfoMessageQuestion:
    "Fournir des compétences spécifiques que les participants acquerront à partir des questions",
  skillsSubtitleQuestion: "Définir les compétences associées à cette question",
  allowedCodingLanguagesInfoQuestion:
    "Choisissez les langues disponibles pour résoudre cette question",
  selectCodingLanguages: "Sélectionnez les langages de codage",
  allLanguages: "Toutes les langues",
  tagsInfoQuestion:
    "Fournir des mots-clés pour catégoriser, décrire et identifier l'événement",
  tagsSubtitleQuestion: "Définir les balises pour une recherche rapide",
  knowledgeCategorySubtitleQuestion:
    "Aide à classer les questions par niveau de compétences cognitives.",
  explanationNotAvailableForSpeakingQuestion:
    "Explication non disponible pour la question orale",
  ownerVersionSyncInfo:
    "Si nous changeons le propriétaire de cette version, elle sera également mise à jour dans toutes les versions créées.",
  ownerInfoMessage:
    "Sélectionnez le(s) propriétaire(s) principal(aux) de la question",
  ownerReviewerCannotBeSame:
    "le propriétaire et l'évaluateur ne peuvent pas être les mêmes",
  reviewerInfoMessage:
    "Sélectionnez une personne ou un groupe de personnes en tant que réviseur(s)",
  stakeholdersUpdatedSuccessfully:
    "Les parties prenantes ont été mises à jour avec succès !",
  unexpectedErrorCreatingNewVersion:
    "Une erreur inattendue s'est produite lors de la création d'une nouvelle version.",
  previewAndPublish: "Aperçu et publication",
  viewAnalytics: "Afficher les analyses",
  cloneQuestionPrompt: "Voulez-vous cloner cette question ?",
  evaluationRubric: "Rubrique d'évaluation",
  problemStatement: "Énoncé du problème",
  problemStatementPlaceholder:
    "Entrez l'énoncé du problème ou l'énoncé du quiz",
  addOptionsAndMarkCorrectAnswer:
    "Ajoutez des options et marquez la bonne réponse",
  markCorrectAnswer: "Marquez la bonne réponse",
  addCorrectAnswer: "Ajouter la bonne réponse",
  enterCorrectAnswerForBlank: "Entrez la bonne réponse pour le {{number}} vide",
  blankWithNumber: "Vide {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Ajoutez un énoncé de problème approprié avec un « & vide » pour activer la réponse.",
  enterSolution: "Entrez la solution",
  enterExplanation: "Entrez l'explication",
  codingSolutionExplanationPlaceholder:
    "Expliquer brièvement la logique, l'approche et les cas extrêmes traités dans la solution optimale",
  optionWithNumber: "Option {{number}}",
  enterExplanationForAnswer: "Entrez l'explication de la réponse {{number}}",
  addOptionToEnableExplanation:
    "Ajoutez l'option {{number}} pour activer l'explication.",
  enterExplanationForBlank: "Entrez l'explication du champ {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Ajoutez un énoncé de problème approprié avec un « & vide » pour activer l'explication.",
  enterHint: "Entrez l'indice",
  addUpTo3Hints: "Ajoutez jusqu'à 3 indices",
  addMoreOptions: "Ajouter plus d'options",
  answer: "Répondre",
  exitCodeBlockInfo:
    'Pour quitter le bloc de code, allez à la fin de la ligne et cliquez trois fois sur "Entrée"',
  fibBlankInsertionInfo:
    'Pour ajouter un espace, sélectionnez du texte et cliquez sur le bouton "Insérer un espace vide", ou ajoutez manuellement &blankN, où N peut être n\'importe quel nombre entier, par exemple : &blank1;',
  htmlEditorAccessInfo:
    "Pour ajouter du code ou contrôler le format, vous pouvez accéder à l'éditeur HTML en cliquant sur l'icône d'édition",
  skillSelectionCannotBeEmpty:
    "La sélection de compétences ne peut pas être vide",
  maxDurationInfo:
    "Temps maximum accordé à un utilisateur pour enregistrer sa réponse à cette question.",
  minDurationInfo:
    "Durée d'enregistrement minimale requise qu'un utilisateur doit effectuer avant de soumettre sa réponse.",
  uploadLimitInfo:
    "Nombre de fois qu'un utilisateur peut réenregistrer sa réponse avant la soumission finale.",
  textQuestionTitle: "Ceci est une question textuelle",
  audioRecordQuestionTitle: "Ceci est une question d'enregistrement audio",
  audioUploadQuestionTitle: "Ceci est une question de téléchargement audio",
  videoRecordQuestionTitle: "Ceci est une question d'enregistrement vidéo",
  videoUploadQuestionTitle: "Ceci est une question de téléchargement de vidéo",
  subjectiveQuestionUploadConfigTitle:
    "Titre de la configuration de téléchargement de question subjective",
  recordingLimitInMinutes: "Limite d'enregistrement (en min)",
  minimumResponseDurationInMinutes: "Durée minimale de réponse (en minutes)",
  recordingLimitLessThanTwenty:
    "La limite d'enregistrement doit être inférieure à 20",
  recordingLimitGreaterThanOrEqualOne:
    "La limite d'enregistrement doit être supérieure ou égale à 1",
  minimumDurationLessThanRecordingLimit:
    "La durée minimale de réponse doit être inférieure à la limite d'enregistrement",
  durationGreaterThanPointFive: "La durée doit être supérieure à 0,5",
  uploadLimitGreaterThanZero:
    "La limite de téléchargement doit être supérieure à 0",
  addFieldSelectCodingLanguagesInfo:
    "Pour ajouter un {{fieldLabel}}, veuillez d'abord sélectionner les langues de codage autorisées dans la section « {{basicDetails}} ».",
  basicDetails: "Détails de base",
  loadingEditor: "Chargement de l'éditeur...",
  run: "Exécuter",
  writingSolutionInLanguage: "Vous écrivez actuellement une solution dans",
  changingToLanguageWillClearInput: "Changer pour",
  unsavedChangesWillBeLostInLanguage: "Vos modifications non enregistrées dans",
  changeLanguage: "Changer de langue",
  testCase: "Cas de test",
  add: "Ajouter",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Ajoutez au minimum 2 cas de test visibles et 3 cas de test cachés ci-dessous",
  visibleToCandidatesForSelfEvaluation:
    "Visible par les candidats pour l'auto-évaluation",
  noVisibleTestCasesAddedYet:
    "Aucun cas de test visible n'a encore été ajouté. Cliquez sur le bouton ci-dessous pour en ajouter un.",
  visibleTestCasesCannotExceedTwenty:
    "Les cas de test visibles ne peuvent pas dépasser 20",
  addMoreVisibleTestCases: "Ajouter des cas de test plus visibles",
  maximumTestCasesLimitReached: "Limite maximale de cas de test atteinte",
  hiddenToCandidatesRunsAfterSubmit:
    "Caché pour les candidats, s'exécute après la soumission du candidat",
  noHiddenTestCasesAddedYet:
    "Aucun cas de test caché n'a encore été ajouté. Cliquez sur le bouton ci-dessous pour en ajouter un.",
  hiddenTestCasesCannotExceedTen:
    "Les cas de test masqués ne peuvent pas dépasser 10",
  addMoreHiddenTestCases: "Ajouter plus de cas de test cachés",
  hiddenTestCase: "Cas de test caché",
  visibleTestCase: "Cas de test visible",
  someQuestionsCouldNotBeUpdated:
    "Certaines questions n'ont pas pu être mises à jour. Veuillez lire les questions et réessayer.",
  publishSummary: "Publier le résumé",
  sendForReviewSummary: "Envoyer pour examen le résumé",
  moveToDraftSummary: "Passer au brouillon du résumé",
  actionSummary: "Résumé des actions",
  publishSummarySubtitle:
    "Voici le résumé de votre action de publication. Consultez les détails ci-dessous.",
  sendForReviewSummarySubtitle:
    "Voici le résumé de votre demande d'examen. Consultez les détails ci-dessous.",
  moveToDraftSummarySubtitle:
    "Voici le résumé de votre passage à l'action de repêchage. Consultez les détails ci-dessous.",
  actionSummarySubtitle:
    "Voici le résumé de votre action. Consultez les détails ci-dessous.",
  successfully: "Avec succès",
  failedTo: "Échec de",
  moveToDraft: "Passer au brouillon",
  details: "Détails",
  questionTitle: "Titre de la question",
  reason: "Raison",
  showLess: "Afficher moins",
  showMoreCount: "Afficher {{count}} plus",
  uploadedAllCountItems: "Tous les {{count}} {{item}} téléchargés",
  partiallyUploadedCountItems:
    "Partiellement téléchargé {{successCount}}/{{totalCount}} {{item}}",
  users: "utilisateurs",
  questions: "des questions",
  viewErrors: "Afficher les erreurs",
  errorsWithFileName: "Erreurs - {{fileName}}",
  inputIsRequired: "Une saisie est requise",
  expectedOutputIsRequired: "Le résultat attendu est requis",
  expectedOutputCannotBeBlank:
    "La sortie attendue ne doit pas être vide ou simplement des espaces",
  marksMustBeNumber: "Les marques doivent être un nombre",
  marksAreRequired: "Des marques sont obligatoires",
  hiddenTestCaseMarksGreaterThanZero:
    "Les notes des cas de test masqués doivent être supérieures à 0 pour continuer.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Les notes pour les cas de test cachés ne doivent pas dépasser 30 000.",
  explanationMinFiveIfProvided:
    "L'explication doit comporter au moins 5 caractères si elle est fournie",
  explanationIsRequired: "Une explication est requise",
  explanationMinFiveNotBlank:
    "L'explication doit comporter au moins 5 caractères et pas seulement des espaces",
  provideInput: "Fournir une contribution",
  provideExpectedOutput: "Fournir le résultat attendu",
  enterScore: "Entrez le score",
  optional: "facultatif",
  explainTestCase: "Expliquer le cas de test",
  updateTestCase: "Mettre à jour le scénario de test",
  addTestCase: "Ajouter un scénario de test",
  deleteQuestionWithTitlePrompt:
    "Êtes-vous sûr de vouloir supprimer cette question intitulée '{{title}}' ?",
  errorFetchingData: "Erreur lors de la récupération des données",
  rowNumber: "Numéro de ligne",
  columnName: "Nom de la colonne",
  useCase: "Cas d'utilisation",
  startsAt: "Commence à",
  endsAt: "Se termine à",
  invite: "Inviter",
  viewReport: "Afficher le rapport",
  successfullyDeletedAssessment: "L'évaluation a bien été supprimée",
  successfullyFreezeActionAssessment: "Réussir {{action}} l'évaluation",
  freezeOperationFailed: "Échec de l'opération de gel",
  deleteAssessmentWithTitlePrompt:
    "Êtes-vous sûr de vouloir supprimer cette évaluation intitulée « {{title}} » ?",
  freeze: "Geler",
  unfreeze: "Dégeler",
  freezeAssessmentPrompt:
    "Êtes-vous sûr de vouloir {{action}} cette évaluation ?",
  expiresAt: "Expire à",
  seePreview: "Voir Aperçu",
  schedule: "Calendrier",
  skillBenchmarking: "Analyse comparative des compétences",
  skillBenchmarkingOverview:
    "Un aperçu de la maîtrise du participant dans des compétences spécifiques.",
  proctoringAnalysis: "Analyse de surveillance",
  proctoringAnalysisOverview:
    "Un aperçu rapide des aspects de l’évaluation liés à la surveillance.",
  proctoringStatus: "Statut de surveillance",
  noIrregularitiesReported: "Aucune irrégularité signalée.",
  monitoringOverview: "Présentation de la surveillance",
  complianceNoIncidents:
    "Respect des règles d'évaluation ; aucun incident ni comportement signalé.",
  viewEvidenceClicked: "Preuve cliqué !",
  marksObtained: "Notes obtenues",
  correctAnswer: "Bonne réponse",
  wrongAnswer: "Mauvaise réponse",
  sectionWiseAnalysis: "Analyse par section",
  sectionWiseAnalysisOverview:
    "Un aperçu de chaque question et la réponse du candidat.",
  openAllSections: "Ouvrir toutes les rubriques",
  closeAllSections: "Fermer toutes les rubriques",
  sectionWithNumber: "Rubrique {{number}} :",
  score: "Score",
  questionAnalysis: "Analyse des questions",
  questionTitleFallback: "Titre de la question",
  candidateAnswer: "Réponse du candidat",
  loadAllQuestions: "Charger tous les {{count}} {{item}}",
  attemptWithNumber: "Tentative #{{number}}",
  invalidReportUrl: "URL du rapport non valide",
  failedToDownloadReportTryAgainLater:
    "Échec du téléchargement du rapport. Veuillez réessayer plus tard !",
  downloadReport: "Télécharger le rapport",
  participantName: "Nom du participant",
  dateOfAttempt: "Date de la tentative",
  fail: "Échouer",
  pass: "Passer",
  userScoredInAssessment:
    "{{name}} a obtenu {{percentage}} lors de l'évaluation.",
  overallSummary: "Résumé général",
  sectionAnalytics: "Analyse des sections",
  allAttempts: "Toutes les tentatives",
  bestAttempt: "Meilleure tentative",
  latestAttempt: "Dernière tentative",
  participantList: "Liste des participants",
  totalParticipantsInvited: "Nombre total de participants invités",
  notStarted: "Non démarré",
  inProgress: "En cours",
  resultsInProgress: "Résultats en cours",
  searchByNameOrEmail: "Rechercher par nom ou par e-mail",
  noUsersAvailableReportCannotBeGenerated:
    "Aucun utilisateur disponible : le rapport ne peut pas être généré.",
  userName: "Nom d'utilisateur",
  totalAttempt: "Tentative totale",
  percentage: "Pourcentage(%)",
  attemptTimeline: "Chronologie de la tentative",
  noDataFound: "Aucune donnée trouvée",
  outOfMarks: "{{obtained}} sur {{max}} marques",
  resultInProcess: "Résultat en cours",
  participantNotFound: "Participant introuvable !",
  searchedParticipantNotFound: "Participant recherché introuvable !",
  noParticipantEnrolled: "Aucun participant inscrit !",
  noDataToDisplay: "Aucune donnée à afficher",
  participantsPerPage: "Participants par page :",
  actionFailed: "L'action a échoué",
  failedToRemoveUser: "Échec de la suppression de l'utilisateur",
  bestScoreAcrossAttemptsInfo:
    "Indique le meilleur score obtenu sur plusieurs tentatives.",
  successfullyRemovedUser: "L'utilisateur a été supprimé avec succès",
  successfullyReinvitedUser: "L'utilisateur a été réinvité avec succès",
  reinviteTooltip:
    "Réinviter les participants qui n’ont pas encore commencé l’évaluation en cours",
  reInvite: "Réinviter",
  noParticipantsInvitedYet: "Aucun participant n'a encore été invité",
  scheduleExpired: "Calendrier expiré",
  assessmentIsOngoing: "L'évaluation est en cours",
  assessmentCompleted: "Évaluation terminée",
  resultNotProcessed: "Résultat non traité",
  assessmentNotStarted: "L'évaluation n'a pas commencé",
  remove: "Retirer",
  confirmReInvitation: "Confirmer la réinvitation",
  confirmReinviteMessage:
    "Êtes-vous sûr de vouloir réinviter les participants qui n'ont pas encore commencé l'évaluation en cours ?",
  removeUserWithNamePrompt: "Êtes-vous sûr de vouloir supprimer « {{name}} » ?",
  groupType: "Type de groupe",
  objectiveGroupType: "Objectif",
  codingGroupType: "Codage",
  subjectiveTextSpeakingGroupType: "Subjectif (Texte / Parler)",
  groupTypeImmutableInfo:
    "Le type de groupe ne peut pas être modifié ultérieurement. Seules des questions de ce type peuvent être ajoutées.",
  sameMarkGroupingTitle:
    "Les questions ne peuvent être regroupées que si elles ont la même valeur de note",
  sameMarkGroupingDescription:
    "Mélanger les valeurs des notes (par exemple, 2 points et 5 points) dans un groupe peut conduire à des scores de section différents lorsque seules certaines questions sont sélectionnées. Regroupez les questions à notes similaires pour que les scores restent cohérents.",
  searchQuestion: "Rechercher une question",
  addAllSelectedQuestions:
    "Ajouter toutes les {{count}} questions sélectionnées",
  singleQuestionSelectedCount: "{{count}} question sélectionnée",
  allQuestionsSelectedCount: "Toutes les {{count}} questions sélectionnées",
  selectedCountOfTotalQuestions:
    "Sélectionnées {{selected}} sur {{total}} {{label}}",
  addSelectedQuestion: "Ajouter la question sélectionnée",
  validationErrors: "Erreurs de validation",
  failedToAddToGroup: "Échec de l'ajout au groupe",
  questionsAddedSuccessfullyWithCount:
    "{{count}} questions ajoutées avec succès",
  successfullyUpdatedAssessment: "Évaluation mise à jour avec succès",
  editCustomTnc: "Modifier les conditions générales personnalisées",
  addCustomTnc: "Ajouter des conditions générales personnalisées",
  attributes: "Attributs",
  added: "Ajoutés",
  addAttributes: "Ajouter des attributs",
  clickHereToAddEditAttributes:
    "Cliquez ici pour ajouter ou modifier des attributs",
  clickHereToAddAttributes: "Cliquez ici pour ajouter des attributs",
  addTncAndSave: "Ajouter les conditions générales et enregistrer",
  savedWithFollowingErrors: "Enregistré avec les erreurs suivantes",
  selectDomain: "Sélectionner le domaine",
  selectRegion: "Sélectionner la région",
  selectUsage: "Sélectionner l'utilisation",
  selectCategoryFirst: "Sélectionner d'abord la catégorie",
  selectSubCategory: "Sélectionner la sous-catégorie",
  addAttributesAndSave: "Ajouter des attributs et enregistrer",
  questionPaperTimer: "Minuteur du questionnaire",
  sectionLevelTimer: "Minuteur au niveau de la section",
  questionLevelTimer: "Minuteur au niveau de la question",
  loginWindowDescription:
    "Les candidats ne peuvent rejoindre le test que dans un laps de temps limité après l'heure de début.",
  durationBasedDescription:
    "L'heure de fin est calculée automatiquement à partir de l'heure de début + la durée du test.",
  deadlineDescription:
    "Heure de début et de fin fixes ; les candidats doivent terminer avant la date limite.",
  loginWindowInfo:
    "La fenêtre de connexion est le temps (en minutes) pendant lequel les candidats peuvent commencer l'évaluation après l'heure de début planifiée. Une fois la fenêtre fermée, aucun nouveau candidat ne peut entrer. La fenêtre de connexion doit être inférieure ou égale à la durée de l'épreuve.",
  assessmentDurationInfo:
    "Définissez uniquement l'heure de début. Le système calculera automatiquement l'heure de fin en ajoutant la durée du test.",
  startTimeMinAheadInfo:
    "L'heure de début doit être avancée d'au moins 15 minutes par rapport à l'heure actuelle.",
  loginWindowExample:
    "Exemple : Si l'heure de début est 9h00 et la fenêtre de connexion est de 30 minutes, les candidats peuvent commencer entre 9h00 et 9h30 avec une marge de 5 minutes supplémentaires.",
  assessmentDurationExample:
    "Exemple : Si l'heure de début est 9h00 et la durée du test est de 60 minutes, l'évaluation se terminera à 10h00 avec une marge de 5 minutes supplémentaires.",
  freeFlow: "Navigation libre",
  oneByOne: "Une par une",
  subjectiveNoResultInfo: "Info subjective sur 'Aucun résultat'",
  candidateResultVisibility: "Visibilité des résultats pour le candidat",
  noResult: "Aucun résultat",
  passPercentageRangeError: "Erreur dans la plage du pourcentage de réussite",
  attemptsAllowedInfo: "Info sur les tentatives autorisées",
  maxAttemptsError: "Erreur : Nombre maximal de tentatives dépassé",
  maximumAttemptsInfo: "Info sur le nombre maximal de tentatives",
  limitedAttempts: "Tentatives limitées",
  coolOffDescription: "Description de la période d'attente",
  noCoolOffPeriod: "Pas de période d'attente",
  waitFor: "Attendre",
  hours: "Heures",
  days: "Jours",
  whatLearnersWillSee: "Ce que les apprenants verront",
  unlimitedAttemptsInfo:
    "Vous disposez d'un nombre illimité de tentatives pour cette évaluation.",
  waitBeforeNextAttemptPrefix: "Après chaque tentative, vous devrez attendre",
  waitBeforeNextAttemptSuffix: "avant de commencer votre prochaine tentative.",
  waitBeforeNextAttempt:
    "Après chaque tentative, vous devrez attendre {duration} avant de commencer votre prochaine tentative.",
  singleAttemptInfo: "Vous avez 1 tentative disponible pour cette évaluation.",
  remainingAttemptsInfoPrefix: "Vous avez",
  remainingAttemptsInfoMiddle: "sur",
  remainingAttemptsInfoSuffix: "tentatives disponibles pour cette évaluation.",
  remainingAttemptsInfo:
    "Vous avez {remaining} sur {total} tentatives disponibles pour cette évaluation.",
  enableCertificate: "Activer le certificat",
  enableCertificateDescription:
    "Délivrez un certificat aux candidats après réussite de l'évaluation.",
  maxAllowed100: "Maximum 100 autorisé",
  scheduleAssessment: "Planifier l'évaluation",
  privateAssessmentLabel: "Évaluation privée",
  publicAssessmentLabel: "Évaluation publique",
  privateAssessmentDescription:
    "Cette évaluation est uniquement sur invitation et n'est disponible que dans la plage horaire de début et de fin définie.",
  publicAssessmentDescription:
    "Cette évaluation prend en charge l'accès auto-attribué et l'accès sur invitation, sans plage horaire d'accès fixe.",
  schedulePublicAssessment: "Planifier l'évaluation publique",
  successfullyPublishedAssessment: "Évaluation publiée avec succès",
  publishWithoutProctoringPrompt:
    "Publier sans surveillance à distance (proctoring) ?",
  publishAssessmentPrompt: "Publier l'évaluation ?",
  sectionScoreAnalysis: "Analyse du score par section",
  sectionScoreAnalysisOverview: "Aperçu de l'analyse du score par section",
  section: "Section",
  noSectionDataAvailable: "Aucune donnée de section disponible",
  difficultyLevelAnalysis: "Analyse du niveau de difficulté",
  browserViolations: "Infractions liées au navigateur",
  videoViolations: "Infractions liées à la vidéo",
  times: "Fois",
  statusMessageUnavailable: "Message de statut indisponible",
  viewViolationEvidence: "Voir les preuves de l'infraction",
  noBrowserViolationsDetected: "Aucune infraction liée au navigateur détectée",
  noVideoViolationsDetected: "Aucune infraction liée à la vidéo détectée",
  candidateNotAttemptedCodingMessage:
    "Message : Le candidat n'a pas tenté l'exercice de programmation",
  candidateCode: "Code du candidat",
  candidateScore: "Score du candidat",
  compilationCount: "Nombre de compilations",
  submissionCount: "Nombre de soumissions",
  timeTaken: "Temps passé",
  testCaseReport: "Rapport des cas de test",
  performanceAndCompilationMetrics:
    "Métriques de performance et de compilation",
  totalTestCases: "Total des cas de test",
  testCasesPassed: "Cas de test réussis",
  testCaseDetails: "Détails des cas de test",
  searchQuestions: "Rechercher des questions",
  clearSearch: "Effacer la recherche",
  question: "question",
  isSelected: "est sélectionné(e)",
  areSelected: "sont sélectionné(e)s",
  selected: "Sélectionné(e)",
  questionsPerPage: "Questions par page :",
  publishQuestions: "Publier les questions",
  send: "Envoyer",
  move: "Déplacer",
  publishQuestionsConfirmation:
    "Êtes-vous sûr de vouloir publier {{count}} {{label}} ?",
  sendForReviewConfirmation:
    "Êtes-vous sûr de vouloir envoyer {{count}} {{label}} pour révision ?",
  moveToDraftConfirmation:
    "Êtes-vous sûr de vouloir déplacer {{count}} {{label}} vers les brouillons ?",
  bulkPublishDisclaimer:
    "Veuillez vérifier que toutes les questions sélectionnées sont complètes, exactes et affichées comme prévu avant de les publier.",
  bulkReviewDisclaimer:
    "Veuillez vérifier que toutes les questions sélectionnées sont complètes, exactes et affichées comme prévu avant de les envoyer pour révision.",
  bulkDraftDisclaimer:
    "Veuillez vérifier que toutes les questions sélectionnées sont complètes, exactes et affichées comme prévu avant de les déplacer vers les brouillons.",
  questionsUnderProcess:
    "Les questions sont en cours de traitement, veuillez cliquer sur voir les détails pour vérifier le statut des questions.",
  mixedStatusesSelected: "Statuts mixtes sélectionnés",
  mixedStatusesWarning:
    "Veuillez vous assurer que toutes les questions sélectionnées ont le même statut avant de continuer.",
  selectionLimitReached: "Limite de sélection atteinte",
  selectionLimitWarning:
    "Vous ne pouvez pas sélectionner plus de {{count}} questions pour une action groupée. Désélectionnez une question avant d'en sélectionner une autre.",
  knowMore: "En savoir plus",
  guideLearnersRightDepth:
    "Guidez vos apprenants avec des questions adaptées au bon niveau de profondeur.",
  bloomCreateDescription:
    "Évaluer la capacité de l'apprenant à concevoir, architecturer ou construire de nouveaux systèmes ou solutions de code en utilisant plusieurs concepts.",
  bloomEvaluateDescription:
    "Vérifier si l'apprenant peut évaluer de manière critique le code, justifier des choix ou évaluer différentes solutions.",
  bloomAnalyzeDescription:
    "Tester la capacité de l'apprenant à décomposer le code, déboguer, suivre la logique ou identifier des modèles dans les systèmes techniques.",
  bloomApplyDescription:
    "Évaluer si l'apprenant peut appliquer des concepts pour résoudre des problèmes pratiques de codage ou des scénarios du monde réel.",
  bloomUnderstandDescription:
    "Vérifier si l'apprenant peut comprendre et expliquer des concepts avec ses propres mots ou interpréter un comportement.",
  bloomRememberDescription:
    "Évaluer la capacité de l'apprenant à se rappeler les définitions de base, la syntaxe et les informations factuelles.",
  bloomVerbCreate: "Créer",
  bloomVerbDesign: "Concevoir",
  bloomVerbConstruct: "Construire",
  bloomVerbDevelop: "Développer",
  bloomVerbEvaluate: "Évaluer",
  bloomVerbJustify: "Justifier",
  bloomVerbDefend: "Défendre",
  bloomVerbAssess: "Apprécier",
  bloomVerbAnalyze: "Analyser",
  bloomVerbDifferentiate: "Différencier",
  bloomVerbOrganize: "Organiser",
  bloomVerbCompare: "Comparer",
  bloomVerbApply: "Appliquer",
  bloomVerbUse: "Utiliser",
  bloomVerbDemonstrate: "Démontrer",
  bloomVerbSolve: "Résoudre",
  bloomVerbExplain: "Expliquer",
  bloomVerbDescribe: "Décrire",
  bloomVerbSummarize: "Résumer",
  bloomVerbInterpret: "Interpréter",
  bloomVerbList: "Lister",
  bloomVerbDefine: "Définir",
  bloomVerbName: "Nommer",
  bloomVerbRecall: "Se rappeler",
  bloomVerbRecognize: "Reconnaître",
  bloomCreateExample1:
    "Créer une application monopage en utilisant React et Redux.",
  bloomCreateExample2:
    "Concevoir un schéma pour la base de données d'une application de covoiturage.",
  bloomCreateExample3:
    "Développer un pipeline CI/CD en utilisant GitHub Actions.",
  bloomEvaluateExample1:
    "Évaluer les avantages et les inconvénients de l'utilisation de NoSQL par rapport à SQL dans une architecture de microservices.",
  bloomEvaluateExample2:
    "Recommander des améliorations pour optimiser les performances du composant React.",
  bloomAnalyzeExample1:
    "Comparer les performances du tri fusion (merge sort) et du tri rapide (quicksort).",
  bloomAnalyzeExample2:
    "Analyser l'utilisation de la mémoire de cette fonction récursive.",
  bloomAnalyzeExample3:
    "Catégoriser les erreurs dans ce bloc de code JavaScript.",
  bloomApplyExample1:
    "Appliquer l'algorithme de recherche binaire pour trouver un élément dans un tableau.",
  bloomApplyExample2:
    "Utiliser une boucle para afficher la suite de Fibonacci en Python.",
  bloomApplyExample3:
    "Résoudre un problème du monde réel en utilisant une table de hachage (hash map).",
  bloomUnderstandExample1:
    "Expliquer le fonctionnement d'une pile en utilisant le principe LIFO.",
  bloomUnderstandExample2:
    "Décrire la différence entre var, let et const en JavaScript.",
  bloomUnderstandExample3: "Interpréter le résultat de la requête SQL fournie.",
  bloomRememberExample1:
    "Identifier la bonne balise HTML pour créer un lien hypertexte.",
  bloomRememberExample2:
    "Nommer les quatre piliers de la programmation orientée objet (POO).",
  bloomRememberExample3: "Lister les types de données primitifs en Java.",
  commonVerbs: "Verbes courants",
  exampleQuestions: "Exemples de questions",
  noExamplesAvailable: "Aucun exemple disponible.",
  candidateResponse: "Réponse du candidat",
  correctQuestions: "Questions correctes",
  totalQuestions: "Nombre total de questions",
  correctQuestionPercentage: "Pourcentage de questions correctes",
  performance: "Performance",
  level: "NIVEAU",
  noOfQuestions: "NOMBRE DE QUESTIONS",
  correctAttempts: "TENTATIVES CORRECTES",
  correctness: "EXACTITUDE",
  partiallyCorrect: "PARTIELLEMENT CORRECT",
  partiallyCorrectPercentage: "POURCENTAGE PARTIELLEMENT CORRECT",
  rescheduleAssessmentPrompt:
    "Veuillez confirmer si vous souhaitez replanifier l'évaluation intitulée « {{title}} »",
  assessmentAlreadyStarted: "L'évaluation a déjà commencé",
  readMore: "Lire la suite",
  best: "Meilleurs",
  latest: "Nouveautés",
  allQuestions: "Toutes les questions",
  myQuestions: "Mes questions",
  publicQuestions: "Questions publiques",
  remarks: "Remarques",
  addRemarks: "Ajouter des remarques",
  noGroupsAdded: "Aucun groupe ajouté pour le moment",
  addGroupInfo:
    "Commencez par créer un groupe pour ajouter des questions. Cliquez sur le bouton « Ajouter un groupe à la section » ci-dessous pour commencer.",
  exitPreview: "Quitter l'aperçu",
  preview: "Aperçu",
  problemStatementNotAdded: "Énoncé du problème non ajouté",
  durationDayUnit: "jour",
  durationDaysUnit: "jours",
  durationHourUnit: "h",
  durationHoursUnit: "h",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Champ personnalisé {{fieldLabel}} ajouté pour {{current}} sur {{total}} langue",
  customFieldAddedForMultipleLanguages:
    "Champ personnalisé {{fieldLabel}} ajouté pour {{current}} sur {{total}} langues",
  email: "Courriel",
  tagInputHint: "Ajouter séparés par des virgules",
  enterOptions: "Entrer des options",
  groupNotFound: "Groupe introuvable",
  sheetNotFound: "Feuille introuvable",
  missingHeaders: "Les en-têtes requis sont manquants",
  assetNotFound: "Ressource introuvable",
  noValidDataFound: "Aucune donnée valide trouvée",
  notFoundPID: "Participant introuvable.",
  invalidParticipants: "Participant invalide.",
  alreadyAdded: "Participant déjà ajouté.",
  duplicateData: "Données en double trouvées.",
  invalidData: "Données invalides.",
  warnings: "Avertissements",
  assignedToMyself: "Assigné à moi-même (Apprentissage Autonome)",
  assignedByMe: "Assigné par moi (Mes Tâches)",
  urlCopiedToClipboard: "URL copiée dans le presse-papiers!",
  failedToCopyUrl: "Erreur lors de la copie de l'URL.",
  content: "Contenu",
  platformHelp: "Ayuda de la plataforma",
  privacyPolicy: "Política de privacidad",
  logout: "Déconnexion",
  logoutConfirmTitle: "Êtes-vous sûr de vouloir vous déconnecter ?",
  logoutConfirmDescription:
    "Vous partez déjà ? Vous pouvez toujours revenir et reprendre là où vous vous êtes arrêté.",
  stayEngaged: "Rester engagé"
} as const;
export default fr;
